var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-manager-side-form-container"},[(_vm.type == 'clear-data')?_c('ClearData',{attrs:{"is-side-form":true}}):_vm._e(),(_vm.type == 'delete-account')?_c('DeleteAccount',{attrs:{"is-side-form":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }